/**
 * Specific dashlet for form dialogs (i.e. dialogs with form)
 */
hrd.AbstractPopup = hrd.AbstractCommonInterface.extend({
	init: function(popup, options){
		var defaults = {
			impl: 'hrd.AbstractPopup'
		};
		this._super($.extend({}, defaults, options));
		this.$dialog = $(popup);
	},
	getDialog: function(){
		return this.$dialog;
	},
	getDialogIdSelector: function(){
		return '#' + this.$dialog.attr('id');
	},
	getDialogButtonPane: function() {
		return this.$dialog.closest('.ui-dialog').find('.ui-dialog-buttonpane');
	},
	closeDialog: function(forceResolve, forceReject){
		forceResolve = forceResolve == undefined ? false : forceResolve;
		forceReject = forceReject == undefined ? false : forceReject;
		if(this.dialogOptions && typeof this.dialogOptions.close == 'function' && !forceReject){
			this.dialogOptions.close(forceResolve);
		} else if(this.$dialog){
			this.$dialog.dialog('close');
		}
	},
	rejectWith: function(rejectData) {
		if(this.dialogOptions && typeof this.dialogOptions.rejectWith == 'function'){
			this.dialogOptions.rejectWith(rejectData);
		}
	},
	rejectWithAndClose: function(rejectData) {
		if(this.dialogOptions && typeof this.dialogOptions.rejectWith == 'function'){
			this.dialogOptions.rejectWith(rejectData);
			this.$dialog.dialog('close');
		}
	},
	usingChromaFlow: function() {
		return this.getDialog().usingChromaFlow();
	},
	restoreProceedButton: function() {
		$('.ok-button', this.$dialog.closest('.ui-dialog')).button('option', 'disabled', false).waiting('done');
	},
	toOriginalPosition: function() {
		this.$dialog.dialog('option', 'position', this.$dialog.dialog('option', 'position'));
	},
	exists: function() {
		return $(this.getDialogIdSelector()).exists();
	},
	startWaiting: function(){
		this.$dialog.waiting();
	},
	endWaiting: function(){
		this.$dialog.waiting('done');
	},
	setTitle: function(title){
		if(this.$dialog){
			this.$dialog.dialog('option', 'title', title);
		}
	},
	appendTitle: function(suffix){
		if(this.$dialog){
			if(this.originalTitle == undefined){
				this.originalTitle = this.$dialog.dialog('option', 'title');
			}
			let title;
			if(!suffix) {
				title = this.originalTitle;
			} else {
				title = `${this.originalTitle} ${suffix}`;
			}
			this.$dialog.dialog('option', 'title', title);
		}
	}
});